import { createFileRoute } from '@tanstack/react-router'
import { InscriptionPage } from '@/pages/InscriptionPage'
import { requireGuest } from '@/utils/routeGuards.ts'

const RouteComponent = () => {
  const { token } = Route.useParams()
  return <InscriptionPage token={token} />
}

export const Route = createFileRoute('/inscription/$token')({
  beforeLoad: requireGuest,
  component: RouteComponent,
})
